import {httpGet, httpPost, httpPut} from "./http";
import {getActivePerson} from "../lib/activeMember";

const fobUrl = window.env.BACKEND_API_URL + '/fobs';

//region CRUD

// Get all fobs associated with a person.
const getFobs = async (signal) => {
    if (getActivePerson() === null) {
        throw new Error('Cannot load account ID from storage');
    }
    const personID = getActivePerson().id;
    const fobIndexUrl = `${fobUrl}/?person_id=${personID}`;

    return httpGet(fobIndexUrl, signal);
}

// Get the fob history of an associated person.
const getFobHistory = async (signal) => {
    if (getActivePerson() === null) {
        throw new Error('Cannot load account ID from storage');
    }
    const personID = getActivePerson().id;
    const fobHistoryUrl = `${fobUrl}/fob_history?person_id=${personID}`;

    return httpGet(fobHistoryUrl, signal);
}

// Create and/or assign a fob to a person.
const createFob = async ({identifier, type, forceAssign}, signal) => {
    const personID = getActivePerson().id;

    const body = {
        'identifier': identifier,
        'type': type,
        'person_id': personID,
        'force_assign': forceAssign
    }

    return await httpPost(fobUrl, body, signal);
}

//endregion

//region Custom routes

// Bless or unbless a fob.
const blessFob = async (fobID, signal) => {
    const blessFobUrl = `${fobUrl}/${fobID}/bless_fob`;

    return await httpPut(blessFobUrl, signal);
}

// Report a fob being lost or stolen.
const lostFob = async (fobID, signal) => {
    const lostFobUrl = `${fobUrl}/${fobID}/lost_fob`;

    return await httpPut(lostFobUrl, signal);
}

// Revoke a fob from being assigned to a person.
const revokeFob = async (fobID, signal) => {
    const revokeFobUrl = `${fobUrl}/${fobID}/revoke_fob`;

    return await httpPut(revokeFobUrl, signal);
}

//endregion

export {
    getFobs,
    getFobHistory,
    createFob,
    blessFob,
    lostFob,
    revokeFob,
}
